import { useQuery } from '@tanstack/react-query'
import { TaskListItem } from '@myapp/contract'
import { taskApi } from '../service'
import { taskKeys } from '../task.keys'

export function useTimelineTasks(from: string, to: string): TaskListItem[] {
  const { data } = useQuery({
    queryKey: taskKeys.list({ plannedStartFrom: from, plannedStartTo: to, _context: 'timeline' }),
    queryFn: () => taskApi.search({ plannedStartFrom: from, plannedStartTo: to, limit: 200, page: 1 }).then((r) => r.data),
    select: (d) => d.items,
  })
  return data ?? []
}
